<template>
  <base-modal @close="$emit('submit', null)" :title="$t('policy_modal_title')">
    <template #content>
      <h1 class="font-weight-medium primary--text title">
        {{ $t('policy_modal_line_1') }}
      </h1>
      <br />
      <h1 class="font-weight-medium primary--text title">
        {{ $t('policy_modal_line_2') }}
      </h1>
      <br />
      <h1 class="font-weight-medium primary--text title">
        {{ $t('policy_modal_line_3') }}
      </h1>
      <br />
      <h1 class="font-weight-medium primary--text title">
        {{ $t('policy_modal_line_4') }}
      </h1>
      <br />
      <v-expansion-panels focusable>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="font-weight-medium primary--text">{{ $t('policy_modal_info_btn') }}</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p class="my-2">
              {{ $t('policy_modal_line_5') }}
            </p>
            <h3 class="font-weight-medium primary--text mb-2">{{ $t('policy_modal_line_6') }}</h3>
            <ul>
              <li>{{ $t('policy_modal_feature_1') }}</li>
              <li>{{ $t('policy_modal_feature_2') }}</li>
              <li>{{ $t('policy_modal_feature_3') }}</li>
              <li>{{ $t('policy_modal_feature_4') }}</li>
            </ul>
            <h3 class="mt-3 font-weight-medium primary--text mb-2">{{ $t('policy_modal_line_7') }}</h3>
            <p>{{ $t('policy_modal_line_8') }}</p>
            <h3 class="font-weight-medium primary--text mb-2">{{ $t('policy_modal_line_9') }}</h3>
            <ul>
              <li>{{ $t('policy_modal_consideration_1') }}</li>
              <li>{{ $t('policy_modal_consideration_2') }}</li>
              <li>{{ $t('policy_modal_consideration_3') }}</li>
            </ul>
            <br />
            <h3 class="font-weight-medium primary--text mb-2 mt-5">{{ $t('policy_modal_legal_notice_1') }}</h3>
            <p>
              {{ $t('policy_modal_legal_notice_2') }}
              {{ $t('policy_modal_legal_notice_3') }}
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <br />
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <ValidationProvider
          :rules="{ required: { allowFalse: false } }"
          :name="$t('policy_modal_terms_and_conditions')"
          v-slot="{ errors }"
        >
          <v-checkbox
            v-model="acceptTerms"
            class="py-0"
            :error-messages="errors"
          >
            <template v-slot:label>
              <span>{{ $t('policy_modal_read_terms_and_conditions') }} </span>
            </template>
          </v-checkbox>
        </ValidationProvider>
        <v-card-actions class="d-flex justify-space-between mt-3">
          <v-btn
            class="mx-2 text-none"
            outlined
            type="submit"
            elevation="0"
            @click="handleSubmit(() => savePolicyNotification('no'))"
            :loading="loading"
          >
            {{ $t('policy_modal_no_authorize_btn') }}
          </v-btn>
          <v-btn
            class="mx-2 text-none"
            color="secondary"
            type="submit"
            elevation="0"
            @click="handleSubmit(() => savePolicyNotification('yes'))"
            :loading="loading"
          >
            {{ $t('policy_modal_authorize_btn') }}
          </v-btn>
        </v-card-actions>
      </ValidationObserver>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/commons/BaseModal'
import NotificationService from '@/services/notification'

export default {
  components: { BaseModal },
  props: {
    accountCode: {
      type: String,
      require: true
    },
    email: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      loading: false,
      acceptTerms: false
    }
  },
  methods: {
    async savePolicyNotification(response) {
      this.loading = true
      try {
        const { status } = await NotificationService.savePolicyResponse(
          this.accountCode,
          { response, email: this.email }
        )

        if (status === 200) {
          this.$emit('submit', null)
        }
      } catch (error) {
        this.$dialog.message.error('No se pudo obtener el listado de monedas.')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="sass">
.v-expansion-panel--active > .v-expansion-panel-header
  min-height: 20px

.title
  font-size: 16px !important
  font-weight: 600 !important
</style>
